import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import DefinirPalavraPasse from "@/pages/DefinirPalavraPasse";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import BolsaProcura from "@/pages/BolsaProcura";
import Financeiro from "@/pages/Financeiro";
import CartaoDigital from "@/pages/CartaoDigital";
import Documentos from "@/pages/Documentos";
import Consultores from "@/pages/Consultores";
import Perfil from "@/pages/Perfil";
import Imoveis from "@/pages/Imoveis";
import ImovelFicha from "@/pages/ImovelFicha";
import Proprietarios from "@/pages/Proprietarios";
import Clientes from "@/pages/Clientes";
import Documentacao from "@/pages/Documentacao";
import Configuracoes from "@/pages/Configuracoes";
import SiteHome from "@/pages/site/SiteHome";
import SiteListings from "@/pages/site/SiteListings";
import SiteProperty from "@/pages/site/SiteProperty";
import { SiteLangProvider } from "@/lib/site";
import { ForcePasswordChange } from "@/components/ForcePasswordChange";

const Site = ({ children }) => <SiteLangProvider>{children}</SiteLangProvider>;


function Protected({ children, adminOnly, roles }) {
  const { user, impersonating } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0D1B2A]">
        <div className="font-display text-2xl gold-text tracking-[0.3em] animate-pulse">ALMAR</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password && !impersonating) return <ForcePasswordChange />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/painel" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/painel" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes key={user?.id || "anon"}>
      <Route path="/login" element={user ? <Navigate to="/painel" replace /> : <Login />} />
      <Route path="/definir-palavra-passe" element={<DefinirPalavraPasse />} />
      <Route path="/painel" element={<Protected><Dashboard /></Protected>} />
      <Route path="/leads" element={<Protected><Leads /></Protected>} />
      <Route path="/bolsa-procura" element={<Protected><BolsaProcura /></Protected>} />
      <Route path="/financeiro" element={<Protected><Financeiro /></Protected>} />
      <Route path="/cartao" element={<Protected><CartaoDigital /></Protected>} />
      <Route path="/documentos" element={<Protected><Documentos /></Protected>} />
      <Route path="/consultores" element={<Protected roles={["admin", "diretor"]}><Consultores /></Protected>} />
      <Route path="/perfil" element={<Protected><Perfil /></Protected>} />
      <Route path="/imoveis" element={<Protected><Imoveis /></Protected>} />
      <Route path="/imoveis/:id" element={<Protected><ImovelFicha /></Protected>} />
      <Route path="/proprietarios" element={<Protected><Proprietarios /></Protected>} />
      <Route path="/clientes" element={<Protected><Clientes /></Protected>} />
      <Route path="/documentacao" element={<Protected><Documentacao /></Protected>} />
      <Route path="/configuracoes" element={<Protected adminOnly><Configuracoes /></Protected>} />
      <Route path="/" element={<Site><SiteHome /></Site>} />
      <Route path="/propriedades" element={<Site><SiteListings /></Site>} />
      <Route path="/propriedades/:id" element={<Site><SiteProperty /></Site>} />
      <Route path="*" element={<Navigate to={user ? "/painel" : "/"} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="bottom-left" theme="dark" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
